import * as PropTypes from 'prop-types'
import {useTranslation} from 'react-i18next'
import {Modal} from '@components/lib'

import {ButtonBottom, Description} from './ModalInfo.styles'

const ModalInfo = ({children, description, buttonText, onClose, ...modalProps}) => {
  const {t} = useTranslation()

  return (
    <Modal onClose={onClose} {...modalProps}>
      {description && <Description>{description}</Description>}
      {children}
      <div>
        <ButtonBottom minWidth='110px' size='sm' onClick={onClose}>
          {buttonText || t('buttons.ok')}
        </ButtonBottom>
      </div>
    </Modal>
  )
}

ModalInfo.propTypes = {
  description: PropTypes.string,
  buttonText: PropTypes.string,
  onClose: PropTypes.func,
  children: PropTypes.node,
}
ModalInfo.defaultProps = {
  description: null,
  buttonText: null,
  onClose: null,
  children: null,
}

export default ModalInfo
